module.exports = __webpack_public_path__ + "img/greenResume.dd3e3b48.svg";